export const COMPANY_NAME = "HCP Amazon LLC";
export const COMPANY_SHORT = "HCP Amazon";
export const COMPANY_INITIALS = "HCP";
export const COMPANY_ADDRESS_FULL = "819 S Oakstone Way, Anaheim, California, US 92806-4640";
export const COMPANY_LOCATION = "Anaheim, California";
export const COMPANY_REGION = "Orange County, California";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=819%20S%20Oakstone%20Way%2C%20Anaheim%2C%20California%2C%20US%2092806-4640";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Profile focus", "value": "Cloud computing" },
  { "label": "Region", "value": "Orange County, California" },
  { "label": "Location", "value": "Anaheim, California" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "HCP Amazon LLC" },
  { "label": "Region", "value": "Orange County, California" },
  { "label": "Address", "value": "819 S Oakstone Way, Anaheim, California, US 92806-4640" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Cloud Architecture", "body": "A concise directory profile for cloud-oriented technology context." },
  { "icon": "✦", "title": "Scalable Infrastructure", "body": "A modern presentation organized around adaptable digital infrastructure." },
  { "icon": "◈", "title": "Security-minded Operations", "body": "A clear, structured profile that keeps public information deliberately minimal." },
  { "icon": "⌁", "title": "Data & Connectivity", "body": "A cloud-inspired view of connected systems and technical environments." },
];
